import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modalforgotpassword',
  templateUrl: './modalforgotpassword.component.html',
  styleUrls: ['./modalforgotpassword.component.scss']
})
export class ModalforgotpasswordComponent implements OnInit {
  @Input() name;

  constructor(public activeModal: NgbActiveModal) {}


  ngOnInit(): void {
  }

}
